import { render } from "./CaseOverviewRow.vue?vue&type=template&id=691187ab&scoped=true"
import script from "./CaseOverviewRow.vue?vue&type=script&lang=js"
export * from "./CaseOverviewRow.vue?vue&type=script&lang=js"

import "./CaseOverviewRow.vue?vue&type=style&index=0&id=691187ab&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691187ab"]])

export default __exports__